const zendeskFn = () => (window ? window['zE'] : undefined);

export const zendeskchatInit = () => {
  if (!zendeskFn()) {
    const script = document.createElement('script');
    script.src = `https://static.zdassets.com/ekr/snippet.js?key=${process.env.ZENDESK_KEY}`;
    script.id = 'ze-snippet';
    document.body.appendChild(script);
  }
};
